<template>
    <!-- 该页面为方便后期维护页面 -->
    <div class="class">
        <div class="headerRenwen">
            <newHeader :activeIndex='activeIndex' />
        </div>
        <div class="banner">
            <img class="bannerRight" style="height: 100%;"
                src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E4%BA%BA%E6%96%87%E8%B4%B4%E5%9B%BE%402x.png"
                alt="">
            <img class="bannerLeftTop"
                src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E6%8D%A2%E5%9B%BE/%E5%AD%A6%E6%80%9D%E8%BE%A8%20%E6%9D%A5%E5%9C%86%E6%A1%8C%20%E5%B0%8F%E7%8F%AD%E4%BA%92%E5%8A%A8%E7%9B%B4%E6%92%AD%E8%AF%BE%402x.png"
                alt="">
            <img class="bannerLeftbutton" @click="OpenDialog"
                src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%8C%89%E9%92%AE%E5%91%80.png"
                alt="">
            <img class="bannerLeftfooter"
                src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E5%89%AF%E6%A0%87%402x.png"
                alt="">
        </div>
        <div class="video_1_box" v-if="configData">
            <div class="video_content">
                <div class="video_title">什么是人文思辨课</div>
                <div class="video_box">
                    <video ref="video1Ref" controls :src="configData.videoUrl" :poster="`${configData.videoUrl}?vframe/jpg/offset/2`"></video>
                </div>
            </div>
        </div>
        <div class="ImgContent">
            <div class="Cone">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/1.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContentGray">
            <div class="CTwo">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/2.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContent">
            <div class="CThree">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/3.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContentGray">
            <div class="CFour">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/4.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContent">
            <div class="CFive">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E6%8D%A2%E6%96%B0%E5%9B%BE/20250513-143802.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContentGray">
            <div class="CSix">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/666.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContent">
            <div class="CSeven">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/7.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContentGray">
            <div class="CSeven">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/8.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContent">
            <div class="CEight">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E8%AF%BE%E7%A8%8B/9.png"
                    alt="">
            </div>
        </div>
        <div class="ImgContentGray">
            <div class="CNine">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E6%8D%A2%E6%96%B0%E5%9B%BE/20250513-143810.png"
                    alt="">
            </div>
        </div>
        <div class="difficulty">
            <div class="diffTitle">选择圆桌星球的理由</div>
            <div class="tig-list" ref="tagList">
                <div class="inner" :style="{
                    transform: `translateX(${translateX}px)`,
                    transition: IsAnmation == false ? 'transform 0.3s ease' : 'transform 0s ease'
                }">
                    <div class="tag" v-for="(tag, index) in tags" :key="index" @click="handleTagClick(index)"
                        :class="{ active: activeTagIndex === index }">
                        {{ tag }}
                    </div>
                </div>


            </div>
            <div class="tig-img" ref="tagImg">
                <div class="inner-img" :style="{
                    transform: `translateX(${translateImgX}px)`,
                    transition: IsAnmation == false ? 'transform 0.3s ease' : 'transform 0s ease'
                }">
                    <img class="tag-img" v-for="(tag, index) in tagsPhoto" :key="index"
                        :class="{ active: activeTagIndex === index }" :src="tag" alt="无法显示">

                    </img>
                </div>
            </div>
            <div class="fadeleft">
                <div class="fadeItemLeft"></div>
            </div>
            <div class="faderight">
                <div class="fadeItemRight"></div>
            </div>
        </div>
        <div class="ImgContent">
            <div class="CTen">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/NewBC.png"
                    alt="">
                <div class="CTenOne"></div>
                <div class="CTenTwo"></div>
                <div class="CTenThree"></div>
                <div class="CTenFour"></div>
            </div>
        </div>
        <div class="ImgContent">
            <div class="CEleven" @mouseover="hoverImg = true" @mouseleave="hoverImg = false">
                <img class="footerImg" :src="hoverImg ? hoverImage : defaultImage" alt="">
            </div>
        </div>
        <div class="ImgContentGray">
            <div class="CAnmitation">
                <div class="AnimtationLeft">
                    <img class="footerImg" :src="soildPhoto[soildIndex].img" :key="soildIndex">
                </div>
                <div class="AnimtationRight">
                    <div class="AnimationText">
                        <div class="Titles">
                            社会影响 <span style="color: #1677ff;">NO.{{ soildPhoto[soildIndex].id }}</span>
                        </div>
                        <div class="content">
                            {{ soildPhoto[soildIndex].text }}
                        </div>
                    </div>
                    <div class="AnimationButton">
                        <div style="display: flex;">
                            <img class="AnimationButtonImg" @click="soildChange(-1)"
                                src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/TurnLeft.png"
                                alt="">
                        </div>
                        <div style="display: flex;">
                            <img class="AnimationButtonImg" @click="soildChange(1)"
                                src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/TurnRight.png"
                                alt="">
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="ImgContent">
            <div class="CTweleve">

                <img class="footerImg"
                    src="https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%8F%91%E5%B1%95.png"
                    alt="">
            </div>
        </div>
        <newQrcode />
        <newFooter />
        <leftButton :isShow.sync="isShow" />
    </div>
</template>

<script>
// @ is an alias to /src
import newHeader from '@/components/newHeader.vue'
import newFooter from '@/components/newFooter.vue';
import newQrcode from '@/components/newQrcode.vue';
import leftButton from '@/components/leftButton.vue';
import { newPostTrackInfo, postTrackInfo, getWebsiteConfigApi } from '@/api';
import { throttle } from '@/utils/utils'

export default {
    name: 'humanities',
    components: {
        newHeader,
        newFooter,
        newQrcode,
        leftButton
    },

    data() {
        return {
            configData: null,
            activeIndex: '0',
            activeTagIndex: 5,
            IsAnmation: false,
            isShow: false,
            tags: [
                '多元化学习内容',  //0
                '双循环思辨教育系统', //1
                '全国首创思辨能力测评', //2
                '沉浸式提问思考',//3
                '科学完善的知识体系',//4
                '多元化学习内容',//5
                '双循环思辨教育系统', //6
                '全国首创思辨能力测评',//7
                '沉浸式提问思考',//8
                '科学完善的知识体系',//9
                '多元化学习内容',//10
                '双循环思辨教育系统', //11
                '全国首创思辨能力测评',//12
                '沉浸式提问思考',//13
                '科学完善的知识体系',//14
            ],
            tagsPhoto: [
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%A4%9A%E5%85%83%E5%8C%96%E5%AD%A6%E4%B9%A0%E5%86%85%E5%AE%B9.png',//0
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%8F%8C%E5%BE%AA%E7%8E%AF%E6%80%9D%E8%BE%A8%E6%95%99%E8%82%B2%E7%B3%BB%E7%BB%9F.png',//1
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%85%A8%E5%9B%BD%E9%A6%96%E5%88%9B%E6%80%9D%E8%BE%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%84.png',//2
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%B9%B3%E7%AD%89%E4%BA%A4%E6%B5%81%E7%9A%84%E5%9C%86%E6%A1%8C%E8%AF%BE%E5%A0%82.png',//3
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E7%A7%91%E5%AD%A6%E5%AE%8C%E5%96%84%E7%9A%84%E7%9F%A5%E8%AF%86%E4%BD%93%E7%B3%BB.png',//4
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%A4%9A%E5%85%83%E5%8C%96%E5%AD%A6%E4%B9%A0%E5%86%85%E5%AE%B9.png',//0
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%8F%8C%E5%BE%AA%E7%8E%AF%E6%80%9D%E8%BE%A8%E6%95%99%E8%82%B2%E7%B3%BB%E7%BB%9F.png',//1
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%85%A8%E5%9B%BD%E9%A6%96%E5%88%9B%E6%80%9D%E8%BE%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%84.png',//2
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%B9%B3%E7%AD%89%E4%BA%A4%E6%B5%81%E7%9A%84%E5%9C%86%E6%A1%8C%E8%AF%BE%E5%A0%82.png',//3
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E7%A7%91%E5%AD%A6%E5%AE%8C%E5%96%84%E7%9A%84%E7%9F%A5%E8%AF%86%E4%BD%93%E7%B3%BB.png',//4
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%A4%9A%E5%85%83%E5%8C%96%E5%AD%A6%E4%B9%A0%E5%86%85%E5%AE%B9.png',//0
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%8F%8C%E5%BE%AA%E7%8E%AF%E6%80%9D%E8%BE%A8%E6%95%99%E8%82%B2%E7%B3%BB%E7%BB%9F.png',//1
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%85%A8%E5%9B%BD%E9%A6%96%E5%88%9B%E6%80%9D%E8%BE%A8%E8%83%BD%E5%8A%9B%E6%B5%8B%E8%AF%84.png',//2
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E5%B9%B3%E7%AD%89%E4%BA%A4%E6%B5%81%E7%9A%84%E5%9C%86%E6%A1%8C%E8%AF%BE%E5%A0%82.png',//3
                'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E9%80%89%E6%8B%A9%E5%9C%86%E6%A1%8C%E6%98%9F%E7%90%83%E7%9A%84%E7%90%86%E7%94%B1/%E7%A7%91%E5%AD%A6%E5%AE%8C%E5%96%84%E7%9A%84%E7%9F%A5%E8%AF%86%E4%BD%93%E7%B3%BB.png',//4
            ],
            soildPhoto: [
                {
                    id: 1,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/1.png',
                    text: '2021年11月，由浙江师范大学高质量育人综合改进研究中心组织、圆桌星球负责师训课程开发，面向杭州市12所公立学校骨干老师的“思辨力”课堂成长营活动顺利举行。'
                },
                {
                    id: 2,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/2.png',
                    text: '2021年12月，由中国智慧研究院哲学教育研修中心、华东师范大学举办的少儿哲学研修营特邀圆桌星球师训专家钱铁铮老师为华东师范大学研修营营员开展《如何上好儿童哲学思辨课》的实训活动。'
                },
                {
                    id: 3,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/3.png',
                    text: '2022年1月，圆桌星球受邀参加杭州滨江区教育研究院主办的区小学名师导航站活动，于杭州市笕桥花园小学为学校青年骨干教师开展师训培训工作。'
                },
                {
                    id: 4,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/4.png',
                    text: '2022年2月，《小学生思辨力培养的教学策略与方法专题培训》正式上线浙江省教育厅教师培训管理平台。'
                },
                {
                    id: 5,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/5.png',
                    text: '2023年1月，圆桌星球与华语辩论世界杯达成战略合作，助力青少年群体思辨表达素养提升，并于2023年华语辩论世界杯全国总决赛中获得小学组冠军及初中组亚军的好成绩。'
                },
                {
                    id: 6,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/6.png',
                    text: '2023年7月，圆桌星球与华东师范大学顺利完成“思辨能力测评项目”签约仪式，共同研发思辨测评项目，设计国内领先的专业化思辨能力测评体系。'
                },
                {
                    id: 7,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/7.png',
                    text: '2023年12月，圆桌星球思辨能力测评正式上线！作为国内思辨行业首创的测评体系，它能够给孩子提供专业化的个人诊断报告，进一步提升孩子的思辨能力。'
                },
                {
                    id: 8,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/8.png',
                    text: '2024年8月，圆桌星球受邀参与2024华语辩论世界杯组全国总决赛，并包揽初中自由组冠军及亚军。'
                },
                {
                    id: 9,
                    img: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%A4%BE%E4%BC%9A%E5%BD%B1%E5%93%8D/9.png',
                    text: '2024年12月，圆桌星球创始人周枫受邀参加浙江省教师培训管理平台教师自主选课项目——“基于儿童哲学的跨学科主题学习设计与实施能力提升培训”活动，并作《思辨的力量——一堂儿童哲学思辨课的设计与实施》主题讲座。'
                }
            ],
            hoverImg: false,
            defaultImage: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%94%9F%E6%BA%90%E5%88%86%E5%B8%83/%E7%94%9F%E6%BA%90%E5%88%86%E5%B8%83.png',
            hoverImage: 'https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E7%94%9F%E6%BA%90%E5%88%86%E5%B8%83/%E7%94%9F%E6%BA%90%E5%88%86%E5%B8%83-1.png',
            soildIndex: 0,

            translateX: 0,
            translateImgX: 0,
            scrollY: 0,
            scrollPercentage: '0.0',
            maxScrollPercentage: 0,
            debounceTimer: null,
            video1Ref: null,
            firstPlay: true,
            maxVideoTime: 0,
        }
    },
    methods: {
        test: throttle(function() {
            console.log('test1111');
            
        }, 1000),
        // 发送视频播放数据
        sendVideoTrackInfo: throttle(function() {
            if (this.maxVideoTime > 0) {
                const data = {
                    current: 'OfficialWebsite',
                    type: 19,
                    platform: 19,
                    content: JSON.stringify([
                        {
                            user: this.$store.state.userNumber,
                        },
                        {
                            action: '播放时长'
                        },
                        {
                            type: '人文思辨课'
                        },
                        {
                            maxVideoTime: this.maxVideoTime
                        }
                    ])
                };
                const userPhone = window.sessionStorage.getItem('userPhone')
                if(userPhone) {
                    // data['phone'] = userPhone
                    let oldContent = JSON.parse(data.content)
                    oldContent.push({
                        phone: userPhone
                    })
                    data.content = JSON.stringify(oldContent)
                }
                newPostTrackInfo(data)
            }
        }, 3000),
        async getConfig() {
            const res = await getWebsiteConfigApi()
            if(res.code === '200') {
                const data = res.data.filter(item => item.location === '人文思辨')
                this.configData = data.length > 0 ? data[0] : null
                console.log(this.configData, '=====>>>>> resresresres');
                this.$nextTick(() => {
                    // 确保视频元素已渲染
                    if (this.$refs.video1Ref) {
                        this.video1Ref = this.$refs.video1Ref;
                        
                        // 监听视频播放完毕事件
                        this.video1Ref.addEventListener('ended', () => {
                           this.sendVideoTrackInfo()
                        });
                        // 监听视频播放事件
                        this.video1Ref.addEventListener('play', () => {
                            if(this.firstPlay) {
                                this.firstPlay = false;
                                const data = {
                                    current: 'OfficialWebsite',
                                    type: 19,
                                    platform: 19,
                                    content: JSON.stringify([
                                        {
                                            user: this.$store.state.userNumber,
                                        },
                                        {
                                            action: '视频点击'
                                        },
                                        {
                                            type: '人文思辨课'
                                        }
                                    ])
                                };
                                const userPhone = window.sessionStorage.getItem('userPhone')
                                if(userPhone) {
                                    // data['phone'] = userPhone
                                    let oldContent = JSON.parse(data.content)
                                    oldContent.push({
                                        phone: userPhone
                                    })
                                    data.content = JSON.stringify(oldContent)
                                }
                                newPostTrackInfo(data);
                            }
                        });
                        // 监听视频时间更新事件（更精确的进度追踪）
                        this.video1Ref.addEventListener('timeupdate', () => {
                            if (this.video1Ref && this.video1Ref.currentTime > this.maxVideoTime) {
                                this.maxVideoTime = this.video1Ref.currentTime;
                                this.sendVideoTrackInfo()
                            }
                        });
                        this.video1Ref.addEventListener('loadedmetadata', () => {
                            const canvas = document.createElement('canvas');
                            canvas.width = this.video1Ref.videoWidth;
                            canvas.height = this.video1Ref.videoHeight;
                            this.video1Ref.currentTime = 0.1; // 取0秒可能取到空白图片，所以最好设置大于0的数字
                            this.video1Ref.addEventListener('loadeddata', () => {
                                const ctx = canvas.getContext('2d');
                                ctx.drawImage(this.video1Ref, 0, 0, canvas.width, canvas.height);
                                const cover = canvas.toDataURL('image/png'); // cover即为视频的封面
                                this.video1Ref.setAttribute('poster', cover); // 设置canvas转化后的图片为封面
                            });
                        });
                    }
                });
            }
        },
        onSwiper(value) {
            // console.log(value)
        },
        soildChange(value) {
            if (this.soildIndex == 8 && value == 1) {
                this.soildIndex = 0
            } else if (this.soildIndex == 0 && value == -1) {
                this.soildIndex = 8
            } else {
                this.soildIndex = this.soildIndex + value
            }



        },
        OpenDialog() {
            let data = {
                type: 19,
                content: JSON.stringify([
                    {
                        user: this.$store.state.userNumber,
                    },
                    {
                        action: '首页领取'
                    },
                    {
                        type: '人文思辨课'
                    }
                ])
            }
            postTrackInfo(data).then(() => {
                this.isShow = true
            })
        },
        handleTagClick(index) {
            this.activeTagIndex = index;
            this.scrollToActiveTag();
            setTimeout(() => {
                switch (index) {
                    case 4:
                        this.activeTagIndex = 9;
                        this.IsAnmation = true
                        this.scrollToActiveTag();


                        break;
                    case 3:
                        this.activeTagIndex = 8;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                    case 2:
                        this.activeTagIndex = 7;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                    case 1:
                        this.activeTagIndex = 6;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                    case 10:
                        this.activeTagIndex = 5;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                    case 11:
                        this.activeTagIndex = 6;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                    case 12:
                        this.activeTagIndex = 7;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                    case 13:
                        this.activeTagIndex = 8;
                        this.IsAnmation = true
                        this.scrollToActiveTag();
                        break;
                }

            }, 400)

        },
        scrollToActiveTag() {
            this.$nextTick(() => {
                const tagList = this.$refs.tagList;
                const tagImg = this.$refs.tagImg;
                const inner = tagList.querySelector('.inner');
                const innerImg = tagImg.querySelector('.inner-img');
                const tag = inner.children[this.activeTagIndex];
                const tagsImg = innerImg.children[this.activeTagIndex];
                const tagWidth = tag.offsetWidth;
                const tagImgWidth = tagsImg.offsetWidth;
                const innerWidth = inner.offsetWidth;
                const innerImgWidth = innerImg.offsetWidth;
                const tagListWidth = tagList.offsetWidth;
                const tagListImgWidth = tagImg.offsetWidth;
                //  console.log(innerWidth, tagWidth, tagListWidth, tagListImgWidth)
                let offsetImg = tagsImg.offsetLeft - (innerImgWidth / 12.1) + (tagImgWidth / 2);
                let offset = tag.offsetLeft - (innerWidth / 4.9) + (tagWidth / 2);
                this.translateImgX = -offsetImg;
                this.translateX = -offset;


                setTimeout(() => {
                    this.IsAnmation = false
                }, 100);
            });
        },
        //监听页面滚动距离
        handleScroll() {
            window.addEventListener('scroll', this.updateScrollY);
        },
        updateScrollY() {
            // 更新滚动距离
            this.scrollY = window.scrollY || document.documentElement.scrollTop;

            // 计算滚动百分比
            const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
            this.scrollPercentage = ((this.scrollY / documentHeight) * 100).toFixed(1);

            // 更新最大滚动百分比
            this.maxScrollPercentage = Math.max(this.maxScrollPercentage, parseFloat(this.scrollPercentage), this.$store.state.RenWenScroll);
            // console.log({
            //     maxScrollPercentage: this.maxScrollPercentage,
            //     scrollPercentage: this.scrollPercentage,
            //     RenWenScroll: this.$store.state.RenWenScroll
            // }, '=====>>> maxScrollPercentage');
            
            this.$store.commit('SET_RENWEN_SCROLL', this.maxScrollPercentage);
            // 防抖处理
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                // 如果当前滚动百分比超过最大值1秒，则请求接口
                if (this.scrollPercentage >= this.$store.state.RenWenScroll) {
                    postTrackInfo({
                        type: 22,
                        content: JSON.stringify([
                            {
                                user: this.$store.state.userNumber,
                            },
                            {
                                action: '页面滑动'
                            },
                            {
                                type: '人文思辨课'
                            },
                            {
                                value: this.scrollPercentage
                            }
                        ])
                    });
                }
            }, 1200);
        },
    },
    mounted() {
        this.scrollToActiveTag();
        this.handleScroll()
        this.getConfig()
        // window.removeEventListener('beforeunload', this.sendVideoTrackInfo);
    },
    beforeDestroy() {
        // 移除滚动事件监听器
        window.removeEventListener('scroll', this.updateScrollY);
        clearTimeout(this.debounceTimer);
        // this.sendVideoTrackInfo()
    },
}
</script>
<style scoped lang="scss">
.headerRenwen {
    position: absolute;
    z-index: 999;
    top: 0;
    // left: 0;
    width: 100%;
}

.banner {
    overflow: hidden;
    height: 560px;
    width: 100%;
    background-image: linear-gradient(to bottom, #2b77f0, #4eb5ff);
    position: relative;

    .bannerRight {
        position: absolute;
        right: 50px;
        top: 0;
    }

    .bannerLeftTop {
        width: 450px;
        height: 140px;
        position: absolute;
        top: 120px;
        left: 120px
    }

    .bannerLeftbutton {
        position: absolute;
        left: 120px;
        top: 300px;
        width: 229px;
        cursor: pointer;
        height: 70px;
    }

    .bannerLeftfooter {
        position: absolute;
        left: 120px;
        top: 400px;
        width: 350px;
        height: 120px;
    }
}

.Cone {
    width: 1200px;
    height: 400px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 342px;
        margin: auto;
    }
}

.CTwo {
    width: 1200px;
    height: 730px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 490px;
        margin: auto;
    }
}

.CThree {
    width: 1200px;
    height: 900px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 660px;
        margin: auto;
    }
}

.CFour {
    width: 1200px;
    height: 912px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 672px;
        margin: auto;
    }
}

.CFive {
    width: 1200px;
    height: 1040px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 800px;
        margin: auto;
    }
}

.CSix {
    width: 1200px;
    height: 1182px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 942px;
        margin: auto;
    }
}

.CSeven {
    width: 1200px;
    height: 805px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 565px;
        margin: auto;
    }
}

.CEight {
    width: 1200px;
    height: 850px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 610px;
        margin: auto;
    }
}

.CNine {
    width: 1200px;
    height: 795px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 555px;
        margin: auto;
    }
}

.CTen {
    width: 1200px;
    height: 720px;
    margin: auto;
    display: flex;
    justify-content: center;
    position: relative;

    .footerImg {
        height: 480px;
        margin: auto;
    }

    .CTenOne {
        position: absolute;
        bottom: 150px;
        left: 40px;
        width: 247px;
        height: 282px;
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/1.png');
        background-size: cover;
        background-position: center;
    }

    .CTenTwo {
        position: absolute;
        bottom: 220px;
        left: 335px;
        width: 247px;
        height: 282px;
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/3.png');
        background-size: cover;
        background-position: center;
    }

    .CTenThree {
        position: absolute;
        bottom: 150px;
        left: 630px;
        width: 247px;
        height: 282px;
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/5.png');
        background-size: cover;
        background-position: center;
    }

    .CTenFour {
        position: absolute;
        bottom: 200px;
        left: 930px;
        width: 247px;
        height: 282px;
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/7.png');
        background-size: cover;
        background-position: center;
    }

    .CTenOne:hover {
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/2.png');
    }

    .CTenTwo:hover {
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/4.png');
    }

    .CTenThree:hover {
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/6.png');
    }

    .CTenFour:hover {
        background-image: url('https://distributionback.myweixue.com/distribution/jjy/%E5%AE%98%E7%BD%91/%E4%BA%BA%E6%96%87%E6%80%9D%E8%BE%A8%E5%8E%8B%E7%BC%A9/%E5%B8%88%E8%B5%84/8.png');
    }
}

.CEleven {
    width: 1200px;
    height: 567px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 327px;
        margin: auto;
    }
}

.CTweleve {
    width: 1200px;
    height: 744px;
    margin: auto;
    display: flex;
    justify-content: center;

    .footerImg {
        height: 504px;
        margin: auto;
    }
}

.CAnmitation {
    width: 1200px;
    height: 640px;
    margin: auto;
    display: flex;
    justify-content: center;

    .AnimtationLeft {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .AnimtationRight {
        flex: 1;
        display: flex;
        width: 540px;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .AnimationText {
            width: 540px;
            height: 320px;

            .Titles {
                font-size: 40px;
                text-align: left;
                height: 52px;
                font-weight: 900;
                line-height: 52px;
                font-family: 'JjyHeave';
            }

            .content {
                margin-top: 10px;
                height: 300px;
                text-align: left;
                line-height: 34px;
                font-size: 20px;
                color: #575e6b;
                font-weight: 400;
                font-family: 'JjySmall';
            }
        }

        .AnimationButton {
            height: 50px;
            width: 540px;
            display: flex;

        }

        .AnimationButtonImg {
            width: 50px;
            height: 50px;
            margin-right: 30px;
            cursor: pointer;
            transition: opacity 0.2s ease;
        }

        .AnimationButtonImg:active {
            opacity: 0.5;
        }
    }

    .footerImg {
        width: 600px;
        height: 400px;
        animation: fadeIn 1.5s forwards;
    }

    @keyframes fadeIn {
        from {
            opacity: 0.5;

        }

        to {
            opacity: 1;
        }
    }
}

.ImgContent {
    width: 100%
}

.ImgContentGray {
    width: 100%;
    background-color: #f6f7fa;
}

.difficulty {
    height: 600px;
    background-color: #1B2266;
    width: 100%;
    position: relative;

    .diffTitle {
        height: 130px;
        color: #ffffff;
        font-family: 'JjyHeave';
        font-size: 40px;
        font-weight: 900;
        line-height: 150px;

        text-align: center;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    }

    .tig-list {
        height: 80px;
        width: 100%;
        position: relative;
        border-bottom: 0.1px solid rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }

    .tig-img {
        height: 370px;
        width: 100%;
        overflow: hidden;
    }

    .tig-list::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 46%;
        width: 100px;
        height: 4px;
        border-radius: 4px;
        background-color: #ffffff;
    }

    .inner {
        width: fit-content;
        display: flex;
        gap: 64px;
        margin: 24px auto;
    }

    .inner-img {
        width: fit-content;
        display: flex;
        gap: 64px;
        margin: 48px auto;
    }

    .tag {
        display: flex;
        align-items: center;
        color: #ffffff;
        cursor: pointer;
        font-size: 18px;
        white-space: nowrap;
        margin-left: 20px;
        font-weight: 400;
        user-select: none;
    }

    .tag-img {
        width: 528px;
        height: 260px;
    }

    .tag.active {
        font-weight: 700;
    }

    .fadeleft {
        position: absolute;
        left: 0;
        top: 0;
        height: 600px;
        width: 360px;
        background: linear-gradient(269.35deg, rgba(27, 34, 102, 0) 0.53%, rgba(27, 34, 102, 0.397722) 39.86%, #1B2266 99.41%);
        pointer-events: none;

    }

    .faderight {
        position: absolute;
        right: 0;
        top: 0;
        height: 600px;
        width: 360px;
        background: linear-gradient(90deg, rgba(27, 34, 102, 0) 0.53%, rgba(27, 34, 102, 0.397722) 39.86%, #1B2266 99.41%);
        pointer-events: none;
    }

    .fadeItemLeft {
        height: 235px;
        float: left;
        width: 120px;
        background-color: #1B2266;
    }

    .fadeItemRight {
        height: 235px;
        float: right;
        width: 120px;
        background-color: #1B2266;
    }
}
.video_1_box {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #F6F7FA;
    padding: 60px 0;
    .video_content {
        width: 1200px;
        display: flex;
        flex-direction: column;
        .video_title {
            width: 1200px;
            font-size: 48px;
            font-weight: 800;
            text-align: center;
        }
        .video_box {
            margin-top: 60px;
            width: 1200px;
            height: 674px;
            overflow: hidden;
            video {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>